import { HelpfulHints } from '../common/HelpfulHints'
import s from '../HelpCenterModal.scss'

const Steps = () => {
  return (
    <div className={s.container}>
      <div className={s.leftContainer}>
        <h3 className={s.title}>Get Started with iDeal CRM</h3>
        <div className={s.content}>
          iDeal CRM is a sales management system built for construction companies to manage
          contacts, opportunities, bids, and follow-up activities.
          <br />
          <br />5 Steps to Get Started:
          <ol className={s.styledList}>
            <li>Add Contacts</li>
            <li>Add Client Companies</li>
            <li>Customize Your Sales Pipeline</li>
            <li>Create Opportunities</li>
            <li>Create & Send Proposals</li>
          </ol>
          Download the{' '}
          <a
            href="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/5+Steps+to+Get+Started+with+iDeal+CRM.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            5 Simple Steps to Get Started with iDeal CRM
          </a>{' '}
          for step-by-step instructions.
          <br />
          <br />
        </div>
      </div>
      <div className={s.rightContainer}>
        <HelpfulHints
          downloadLink="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/5+Steps+to+Get+Started+with+iDeal+CRM.pdf"
          thumbnailUrl="https://ideal-help.s3.us-east-2.amazonaws.com/thumbnails/5+Steps+to+Get+Started+with+iDeal+CRM.jpg"
          text="5 Steps to Get Started with iDeal CRM"
        />
      </div>
    </div>
  )
}

export default Steps
